(function () {
	angular
		.module('trackeye')
		.controller('AccountController', AccountController);

	AccountController.$inject = [];

	/**
	 * Should replace the user controller
	 * @constructor
	 */
	function AccountController() {
		var vm = this;


	}
})();